import type { ShiftsRow, View } from 'modules/shift_management/lib/types'

export const getResources = (shiftsRow: ShiftsRow, date: moment.Moment, view: View) => {
  const shifts = shiftsRow.shiftsByDate(date, view)
  const isNotFirstDayDailyView =
    view.isDaily && date.format('HH') != date.clone().startOf('day').format('HH')
  const leaves = isNotFirstDayDailyView ? [] : shiftsRow.leaves.filterByDate(date)
  const holidays = isNotFirstDayDailyView ? [] : shiftsRow.holidays.filterByDate(date)
  const restDays = isNotFirstDayDailyView ? [] : shiftsRow.restDays.filterByDate(date)

  // There can only be 1 holiday and 1 rest day per date due to a
  // date uniqueness constraint in the backend models
  const holiday = holidays?.length ? holidays[0] : undefined
  const restDay = restDays?.length ? restDays[0] : undefined

  return { shifts, leaves, holiday, restDay }
}
